export namespace WebpHelper {
    let webpSupport: boolean = null;
    export const webpUrl = (url: string) => url.replace(/\.(png|jpg|jpeg)/g, ".webp");

    const source = (srcset: string, type: string) =>
        `<source srcset="${srcset}" type="image/${type == "jpg" ? "jpeg" : type}">`;

    const webpSource = (imgUrlx1: string, imgUrlx2: string) => {
        const srcSet = imgUrlx2 ? `${webpUrl(imgUrlx1)} 1x, ${webpUrl(imgUrlx2)} 2x` : webpUrl(imgUrlx1);
        return source(srcSet, "webp");
    };

    const imgSource = (imgUrlx1: string, imgUrlx2: string) => {
        const type = imgUrlx1.includes(".png") ? "png" : "jpeg";
        const srcSet = imgUrlx2 ? `${imgUrlx1} 1x, ${imgUrlx2} 2x` : imgUrlx1;
        return source(srcSet, type);
    };

    const pictureTag = (
        img1x: string,
        img2x: string,
        alt: string,
        cssClass = "",
        width: number,
        height: number,
        isLazyload = true
    ) => {
        return `
        <picture>
            ${webpSource(img1x, img2x)}
            ${imgSource(img1x, img2x)}
            <img src="${img1x}" ${isLazyload ? 'loading="lazy"' : ""} alt="${alt}"${
            cssClass ? ` class="${cssClass}"` : ""
        }${width ? ` width="${width}"` : ""}${height ? ` height="${height}"` : ""} />
        </picture>
        `;
    };

    export const hasWebpSupport = () => {
        if (webpSupport === null) {
            webpSupport = document.documentElement.className.indexOf("webp") >= 0;
        }
        return webpSupport;
    };

    const videoTag = (fallback: string, videoSource: string, alt: string, cssClass = "") => {
        const img = hasWebpSupport() ? webpUrl(fallback) : fallback;
        return `
        <video class="${cssClass}" autoplay="" loop="" muted="" playsinline="true" loading="lazy" poster="${img}">
            <source src="${videoSource}" type="video/webm">
            <img alt="${alt}" class="${cssClass}" loading="lazy" src="${img}">
        </video>
        `;
    };

    export const createPictureTag = (
        imageUrl: string,
        alt: string,
        cssClass?: string,
        width?: number,
        height?: number,
        isLazyload?: boolean
    ) => {
        if (!imageUrl) return "";
        const images = imageUrl.split("|").filter((x) => x);
        const img1x = images[0];
        const img2x = images[1];
        const isVideo = img1x.indexOf(".webm") >= 0;
        return isVideo
            ? videoTag(img2x, img1x, alt, cssClass)
            : pictureTag(img1x, img2x, alt, cssClass, width, height, isLazyload);
    };
}
